// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-container[data-v-3eba5742] {\n  padding: 10px 0;\n}\n.filter-item[data-v-3eba5742] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
